/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchDto { 
    searchType?: SearchDtoSearchTypeEnum;
    searchObject?: string;
}
export enum SearchDtoSearchTypeEnum {
    ProductQuick = 'PRODUCT_QUICK',
    SubmissionQuick = 'SUBMISSION_QUICK',
    ProductAdvanced = 'PRODUCT_ADVANCED',
    SubmissionAdvanced = 'SUBMISSION_ADVANCED'
};



